import { createFileRoute, notFound } from "@tanstack/react-router";
import { ErrorComponent } from "@/components/Error";
import { NotFound } from "@/components/NotFound";
import { Contact } from "@/contacts/Contact";
import { graphql } from "@/graphql";
import { apolloClient } from "@/lib/apollo-client";

export const supplyChainPartnerNameQuery = graphql(`
  query SupplyChainPartnerName($id: UUID!) {
    supplyChainPartner(id: $id) {
      id
      businessName
    }
  }
`);

export const Route = createFileRoute("/(authed)/_layout/contacts/$contactId")({
  notFoundComponent: (props) => (
    <NotFound
      title="Contact not found."
      message="The contact you are looking for does not exist."
      backToPath="/contacts"
      {...props}
    />
  ),
  errorComponent: (props) => (
    <ErrorComponent
      title="Contact Error"
      message="There was a problem loading this contact."
      backTo={{
        path: "/contacts",
        text: "Back to contacts",
      }}
      {...props}
    />
  ),
  component: RouteComponent,
  loader: async ({ params }) => {
    const { contactId } = params;

    const { data } = await apolloClient.query({
      query: supplyChainPartnerNameQuery,
      variables: {
        id: contactId,
      },
    });
    if (!data?.supplyChainPartner) {
      throw notFound();
    }
    const contact = data ? `${data.supplyChainPartner?.businessName}` : "Contact Info";
    return {
      crumb: contact,
    };
  },
});

function RouteComponent() {
  const { crumb } = Route.useLoaderData();
  return <Contact contactName={crumb} />;
}
